import store from "../store";

export function checkIsLogin(to, from, next) {
  const isLogin = store.state.tokenContent && store.state.userInfo;
  console.log(isLogin);
  // if (isLogin) next();
  // else next({ name: "login" });
  next();
}
